<div style="display: inline-flex; align-items: flex-start;"
    [ngStyle]="{
        'width': fullWidth ? '100%' : 'inherit'
    }">
    <mat-form-field [ngClass]="{'isError': isError}"
        [floatLabel]="floatLabel"
        style="margin-top: inherit; margin-bottom: inherit; min-width:130px; flex: 1 0;"
        [appearance]="appearance"
        [hideRequiredMarker]="hideRequiredMarker">

        <!-- Display date -->
        <input matInput
            #dateInput
            id='dp{{id}}'
            [(ngModel)]="displayValue"
            [ngModelOptions]="{
                'updateOn': 'blur'
            }"
            name="displayControl{{id}}"
            tabIndex="{{tabIndex}}"
            [textMask]="mask"
            (blur)="displayDateChanged()"
            (keydown)="updated = false; $event.key == 'Enter' ? enterPressed() : null;"
            (focus)="clearIfInvalid()"
            [required]="isRequired"
            [disabled]="disabled"
            autocomplete="off"
            dateValidator >

        <!-- Date control -->
        <input id="hdnDateInput{{id}}"
            style="display: none"
            [matDatepicker]="datepicker"
            [(ngModel)]="localValue"
            name="hiddenControl{{id}}"
            (dateChange)="calendarDateChanged()"
            [disabled]="disabled" />

        <!-- Date selector -->
        <div matSuffix
            style="display: flex; align-items: baseline;">
            <ng-container *ngIf="clearable && hovering && innerValue">
                <button mat-icon-button
                    style="align-self: start;"
                    color="warn"
                    (click)="clear()"
                    [attr.id]="label + 'ClearButton'">
                    <mat-icon aria-hidden="true">
                        clear
                    </mat-icon>
                </button>
            </ng-container>
            <mat-datepicker-toggle [for]="datepicker"></mat-datepicker-toggle>
            <ng-content ></ng-content>
        </div>

        <!-- Accessories -->
        <mat-datepicker #datepicker></mat-datepicker>
        <mat-label *ngIf="!showLabelAsHint && (!isRequired || !truncateLabel)">{{label | translate}}</mat-label>
        <mat-label *ngIf="!showLabelAsHint && isRequired && truncateLabel" style="max-width: 90%; text-overflow: ellipsis; overflow: hidden; display: block; white-space: nowrap;">
            <span *ngIf="!postLabelSpace">{{label | translate}}</span>
            <span *ngIf="postLabelSpace">{{label | translate}}&nbsp;</span>
        </mat-label>
        <mat-hint *ngIf="!showLabelAsHint && customHint==''">mm/dd/yyyy</mat-hint>
        <mat-hint *ngIf="showLabelAsHint && customHint==''">{{label | translate}}</mat-hint>
        <mat-hint *ngIf="customHint!=''" style="white-space: nowrap;">{{customHint | translate}}</mat-hint>
        <mat-error [id]="id+'Error'">
            <ng-container *ngIf="errorMessage">{{errorMessage | translate}}</ng-container>
            <ng-container *ngIf="!errorMessage">
                <span *ngIf="displayValue" translate>Invalid date</span>
                <span *ngIf="!displayValue" translate>Required field</span>
            </ng-container>
        </mat-error>
    </mat-form-field>

    <!-- Today Button -->
    <tyl-button *ngIf="showTodayButton"
        style="padding-top: 9px; padding-left: 10px;"
        image="calendar with checkmark.png"
        disabledImage="calendar with checkmark disabled.png"
        (clickEvent)="todayClick()"
        [disabled]="disabled"
        [noPadding]="true"></tyl-button>
</div>
